export default props => {
  return (
    <span className='user-tag'>{props.tag.name}</span>
  )
}